import React, { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";
import "./../style.css";
import "./../style1.css";
import { useNavigate, useParams } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useSelector } from "react-redux";
import { Helmet } from 'react-helmet';
import { ToastContainer, toast } from 'react-toastify';
import Rightsidebar from "../Rightsidebar/Rightsidebar";
import Loader from "../CommonLoader";
import DatagridComp from "../DatagridComp";
import { Commonfun, removeDuplicateDate } from './../Commonfun';
import { Utils } from "../../../Utils/Utils";
import Freeaudit from "../../../Utils/Freeaudit";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { timezonechange } from './../Commonfun';
import { timezoneval } from './../Commonfun';
import { AppContext } from "../../../Context/Context";
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import CommonBreadCrumb from "../../../Commonalert/commonbreadcrumb";
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from "@mui/material/Box";
import UserActivityTracker from "../../../hooks/userActivityTracker";


export default function AiPerformanceTracking() {

    const param = useParams();
    const navigate = useNavigate();
    const ticketId = param.id;
    const esodata = useSelector((state) => state);
    const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);
    const apiToken = esodata?.apiauthkey?.value;
    const [apiopen, setapiOpen] = useState(false);
    const [apierrorMsg, setapierrorMsg] = useState();
    const [loading, setLoading] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);
    const [isDownloadingcsv, setIsDownloadingcsv] = useState(false);
    const [tableColumns, setTableColumns] = useState([]);
    const [tableRows, setTableRows] = useState([]);
    const [tableLoading, setTableLoading] = useState(false);
    const ApiToken = apiToken;
    const menuItemStyle = {
        padding: "10px 16px",
        cursor: "pointer",
        borderBottom: "1px solid #eee",
        backgroundColor: "#fff",
        transition: "background 0.2s",
    };

    const providers = ['openai', 'gemini', 'perplexity', 'copilot', 'claude'];
    const [activeTab, setActiveTab] = useState(0);
    const [providerData, setProviderData] = useState({});
    const [inputs, setInputs] = useState(
        providers.reduce((acc, prov) => {
            acc[prov] = { url: '', query: '', errUrl: '', errQuery: '' };
            return acc;
        }, {})
    );

    //faq
    const [faqData, setfaqData] = useState("2")
    const [toggle, setToggle] = useState(false);
    const [initialfaqDateval, SetInitialfaqDateval] = useState([]);
    //run report
    const [isReportOpen, setIsReportOpen] = useState(false);
    const [successApiopen, setSuccessApiOpen] = useState(false);
    const [successApierrorMsg, setSucessApierrorMsg] = useState('');
    const [performancePlan, setperformancePlan] = useState({ status: true, error: "" });
    const [citedUrlModalOpen, setCitedUrlModalOpen] = useState(false);
    const [selectedCitedUrls, setSelectedCitedUrls] = useState([]);


    useEffect(() => {
       checkUserPlan();
    }, []);
    const apihandleClose = () => {
        setapiOpen(false);
    }

    const pdfdown = async () => {

        setLoading(true);
        setIsDownloading(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}technical/ai_citation_table/?user_domain_id=${esodata.domaindata.value.header_selected}&formats=pdf&timezone=${timezoneval()}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/pdf',
                    Authorization: `${apiToken}`,
                },
            });

            if (response.ok) {

                const blob = await response.blob();


                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                var filedata = await Commonfun("AiPerformanceTracking", "pdf", apiToken, esodata.domaindata.value.header_selected);
                link.download = filedata;
                link.click();


                window.URL.revokeObjectURL(link.href);
            } else {
                if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
                    response.json().then(data => {
                        setapiOpen(true);
                        setapierrorMsg(data?.error)
                    })
                }
                else if (response?.code == "ERR_NETWORK") {
                    navigate('/errorpages')
                }
            }
        } catch (error) {
            toast.error("No Data", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            console.error('Error during PDF download:', error);
        }
        setLoading(false);
        setIsDownloading(false);


    }

    const csvdown = async () => {
        setLoading(true);
        setIsDownloadingcsv(true);
        try {
              const response = await fetch(`${process.env.REACT_APP_API_URL}technical/ai_citation_table/?user_domain_id=${esodata.domaindata.value.header_selected}&formats=csv&timezone=${timezoneval()}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/csv',
                    Authorization: `${apiToken}`,
                },
            });
            if (response.ok) {
                const blob = await response.blob();
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = 'AiPerformanceTracking.csv';

                link.click();


                window.URL.revokeObjectURL(link.href);
            } else {
                if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
                    response.json().then(data => {
                        setapiOpen(true);
                        setapierrorMsg(data?.error)
                    })
                }
                else if (response?.code == "ERR_NETWORK") {
                    navigate('/errorpages')
                }
            }
        } catch (error) {
            toast.error("No Data", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            console.error('Error during PDF download:', error);
        }
        setLoading(false);
        setIsDownloadingcsv(false);

    }
 const Submit = async (provider) => {
        const input = inputs[provider];
        let errUrl = '', errQuery = '';
        if (!input.url) {
            errUrl = "Please enter url";
        } else {
            const urlPattern = /^(https?:\/\/)[^\s$.?#].[^\s]*$/i;
            if (!urlPattern.test(input.url)) {
                errUrl = "Please Enter Valid url";
            }
        }
        if (!input.query) {
            errQuery = "Please enter Query";
        }
        setInputs(prev => ({ ...prev, [provider]: { ...prev[provider], errUrl, errQuery } }));
        if (!errUrl && !errQuery) {
            setLoading(true);
            axios.get(`${process.env.REACT_APP_API_URL}technical/ai_citation/?user_domain_id=${esodata.domaindata.value.header_selected}&url=${input.url}&query=${input.query}&provider=${provider}`, {
                headers: {
                    Authorization: `${apiToken}`,
                }
            }).then(sslConfig => {
                setProviderData(prev => ({ ...prev, [provider]: sslConfig.data }));
                setInputs(prev => ({ ...prev, [provider]: { url: '', query: '', errUrl: '', errQuery: '' } }));
                setLoading(false);
            }).catch(error => {
                if (
                    error?.response?.status == 599 ||
                    error?.response?.status == 400 ||
                    error?.response?.status == 500
                ) {
                    setapiOpen(true);
                    setapierrorMsg(error?.response?.data?.error)
                    setLoading(false);
                } else if (
                    error?.code == "ERR_NETWORK" ||
                    error?.response?.status == 404
                ) {
                    navigate("/errorpages");
                }
            });
        }
    }; 
    const handleReset = (provider) => {
        setInputs(prev => ({ ...prev, [provider]: { url: '', query: '', errUrl: '', errQuery: '' } }));
    };

    const handleToggle = () => {
        if (faqData != 1) {
            setfaqData(1)
        }
        else {
            setfaqData(2)
        }
        setToggle((pre) => !pre);
    };

    const faqdatafun = async (menubutval = "") => {
        var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=90`

        try {
            const doaminsectiondatavalue = await axios.get(
                datavar,
                {
                    headers: {
                        Authorization: `${apiToken}`,
                    },
                }
            ).catch((error) => {
                if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
                    setapiOpen(true);
                    setapierrorMsg(error?.response?.data?.error)
                }
                else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
                    navigate('/errorpages')
                }
            });
            if (doaminsectiondatavalue?.data) {
                SetInitialfaqDateval(doaminsectiondatavalue?.data?.faqs)
            }
        } catch (err) { }
    }

    const getTableColumns = () => {
        return [
            {
                field: "query",
                headerName: "Query",
                minWidth: 250,
                flex: 1.2,
                sortable: true,
                headerAlign: "center",
                align: "left",
                description: "The search query used to test AI providers",
                renderCell: (params) => {
                    const value = params.value;
                    return value ? String(value) : "-";
                },
            },
            {
                field: "url",
                headerName: "URL",
                minWidth: 220,
                flex: 1,
                sortable: true,
                headerAlign: "center",
                align: "left",
                description: "The website URL being checked for citations",
                renderCell: (params) => {
                    const value = params.value;
                    return value ? (
                        <a href={value} target="_blank" rel="noopener noreferrer">
                            {value}
                        </a>
                    ) : "-";
                },
            },
            {
                field: "cited_url",
                headerName: "Cited URLs",
                minWidth: 180,
                flex: 1,
                sortable: false,
                headerAlign: "center",
                align: "center",
                description: "The URLs cited by the AI provider in its response",
                renderCell: (params) => {
                    const value = params.value;
                    if (Array.isArray(value) && value.length > 0) {
                        return (
                            <button
                                onClick={() => {
                                    setSelectedCitedUrls(value);
                                    setCitedUrlModalOpen(true);
                                }}
                                style={{
                                    backgroundColor: "#ff6600",
                                    color: "white",
                                    border: "none",
                                    padding: "6px 12px",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                    fontSize: "11px",
                                    fontWeight: "500",
                                    whiteSpace: "nowrap",
                                    overflow: "visible",
                                    display: "inline-block",
                                }}
                            >
                                View ({value.length})
                            </button>
                        );
                    }
                    return "-";
                },
            },
            {
                field: "ai_model",
                headerName: "Provider",
                minWidth: 160,
                flex: 0.9,
                sortable: true,
                headerAlign: "center",
                align: "center",
                description: "The AI provider or model used (e.g., OpenAI, Gemini, Claude)",
                renderCell: (params) => {
                    const value = params.value;
                    return value ? String(value) : "-";
                },
            },
            {
                field: "cited",
                headerName: "Cited",
                minWidth: 100,
                flex: 0.8,
                sortable: true,
                headerAlign: "center",
                align: "center",
                description: "Indicates whether the URL was cited by the AI provider",
                renderCell: (params) => {
                    const value = params.value;
                    if (value == null) return "-";
                    return value ? (
                        <CheckCircleIcon style={{ color: "green" }} />
                    ) : (
                        <CancelIcon style={{ color: "red" }} />
                    );
                },
            },
            {
                field: "created_at",
                headerName: "Created At",
                minWidth: 180,
                flex: 1,
                sortable: true,
                headerAlign: "center",
                align: "center",
                description: "The date and time when this record was created",
                renderCell: (params) => {
                    const value = params.value;
                    if (value) {
                        const date = new Date(value);
                        return date.toLocaleString("en-US", {
                            year: "numeric",
                            month: "short",
                            day: "numeric",
                        });
                    }
                    return "-";
                },
            },
        ];
    };

    const extractTableRows = (json) => {
        if (Array.isArray(json)) return json;
        if (json?.data && Array.isArray(json.data)) return json.data;
        if (json?.result && Array.isArray(json.result)) return json.result;
        if (json?.rows && Array.isArray(json.rows)) return json.rows;
        return [];
    };

    const loadCitationTableData = async () => {
        setTableLoading(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}technical/ai_citation_table/?user_domain_id=${esodata.domaindata.value.header_selected}&formats=table&timezone=${timezoneval()}`, {
                method: 'GET',
                headers: {
                    Authorization: `${apiToken}`,
                },
            });
            if (response.ok) {
                const json = await response.json();
                const rows = extractTableRows(json);
                setTableRows(rows.map((row, index) => ({ id: row.id ?? index + 1, ...row })));
                setTableColumns(getTableColumns());
            } else {
                if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
                    response.json().then((data) => {
                        setapiOpen(true);
                        setapierrorMsg(data?.error);
                    });
                } else if (response?.code == "ERR_NETWORK") {
                    navigate('/errorpages');
                }
            }
        } catch (error) {
            console.error('Error loading citation table:', error);
            setapiOpen(true);
            setapierrorMsg('Unable to load citation table');
        }
        setTableLoading(false);
    };

    const checkUserPlan = async () => {
        const performanceP = await Utils("ai_citation_report", ApiToken);
        if (performanceP.status) {
            faqdatafun();
            loadCitationTableData();
        }
        setperformancePlan(performanceP);
    };

    const successApiClose = () => {
        setSuccessApiOpen(false);
    };

    return (
        <><ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
        />
            <Helmet>
                <meta charSet="utf-8" />
                <title>AI Citation Report</title>
            </Helmet>
            {loading === true ? <Loader /> : null}
            <div className={`over_all_container over_all_accessibility ${isMenuExpanded ? "blur overflow-hidden" : ""}`}>
                <Container maxWidth={false} className="dashboard-container">
                    <Box className="dashboard-box">
                        <Grid container className="dashboard-grid">
                            <Grid item xs={12} md={4}>
                                <div>
                                    <h1 className="dashboard_header">
                                        AI Citation Report
                                        <span className="faq-chip" onClick={handleToggle}>FAQ's</span>
                                    </h1>
                                </div>
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <div className="top_breadcrumb_menu">
                                    <div className="exportpdf_outer">
                                        <div className="breadcrumb-wrapper">
                                            <CommonBreadCrumb breadcrumbValue={[
                                                { title: 'AI Citation Report', active: true },
                                                // { title: 'SSL Configuration', active: true }
                                            ]} />
                                        </div>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Box>
                </Container>
                <Container maxWidth={false} className="dashboard-container">
                        <Box className="dashboard-box-time">
                          <Grid container className="dashboard-grid">
                            <Grid item xs={12} md={6}>
                            
                            </Grid>
                            <Grid item xs={12} md={6}>
                              
                            </Grid>
                          </Grid>
                        </Box>
                      </Container>
                {performancePlan.status ? (
                <Container maxWidth={false} className="dashboard-card-container">
                    <Box className="dashboard-box-card">
                        <Grid container className="dashboard-card-grid">
                            <Grid item xs={12} md={12}>
                              
                                <div className="">
                                    <div className="color-checker-container">
                                        <div className="trendy-tabs-wrapper">
                                            <div className="trendy-tab-container">
                                                {providers.map((prov, idx) => (
                                                    <button
                                                        key={prov}
                                                        type="button"
                                                        className={`trendy-tab ${activeTab === idx ? "active" : ""}`}
                                                        onClick={() => setActiveTab(idx)}
                                                    >
                                                        {prov.charAt(0).toUpperCase() + prov.slice(1)}
                                                    </button>
                                                ))}
                                            </div>
                                        </div>
                                        {providers.map((prov, idx) => (
                                            activeTab === idx && (
                                                <div key={prov} style={{ marginTop: '20px' }}>
                                                    <div className="ai-form-container" style={{ marginBottom: '20px' }}>
                                                        <div className="ai-form-group">
                                                            <label className="ai-form-label">URL</label>
                                                            <input
                                                                type="text"
                                                                className="ai-form-input"
                                                                value={inputs[prov].url}
                                                                placeholder="Enter URL"
                                                                onChange={(e) => setInputs(prev => ({ ...prev, [prov]: { ...prev[prov], url: e.target.value } }))}
                                                            />
                                                            <div className="ai-form-hint">Must start with http:// or https://</div>
                                                            <div className="ai-form-error">{inputs[prov].errUrl}</div>
                                                        </div>

                                                        <div className="ai-form-group">
                                                            <label className="ai-form-label">Query</label>
                                                            <input
                                                                type="text"
                                                                className="ai-form-input"
                                                                value={inputs[prov].query}
                                                                placeholder="Enter Query"
                                                                onChange={(e) => setInputs(prev => ({ ...prev, [prov]: { ...prev[prov], query: e.target.value } }))}
                                                            />
                                                            <div className="ai-form-error">{inputs[prov].errQuery}</div>
                                                        </div>

                                                        <div className="ai-form-actions">
                                                            <button
                                                                className="ai-submit-btn"
                                                                onClick={() => Submit(prov)}
                                                            >
                                                                Submit
                                                            </button>
                                                            <button
                                                                className="ai-reset-btn"
                                                                onClick={() => handleReset(prov)}
                                                            >
                                                                Reset
                                                            </button>
                                                        </div>
                                                    </div>
                                                    {providerData[prov] && (
                                                        <table
                                                            style={{
                                                                width: "100%",
                                                                borderCollapse: "collapse"
                                                            }}
                                                        >
                                                            <col style={{ width: "50%" }} />
                                                            <col style={{ width: "50%" }} />
                                                            <tbody>
                                                                <tr>
                                                                    <td
                                                                        style={{
                                                                            fontWeight: 800,
                                                                            verticalAlign: "middle",
                                                                            padding: "10px 8px"
                                                                        }}
                                                                    >
                                                                        URL:
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            verticalAlign: "middle",
                                                                            padding: "10px 8px"
                                                                        }}
                                                                    >
                                                                        {providerData[prov]?.url ? (
                                                                            <a
                                                                                href={providerData[prov].url}
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                            >
                                                                                {providerData[prov].url}
                                                                            </a>
                                                                        ) : (
                                                                            "-"
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td
                                                                        style={{
                                                                            fontWeight: 800,
                                                                            verticalAlign: "middle",
                                                                            padding: "10px 8px"
                                                                        }}
                                                                    >
                                                                        Query:
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            verticalAlign: "middle",
                                                                            padding: "10px 8px"
                                                                        }}
                                                                    >
                                                                        {providerData[prov]?.query ? (
                                                                            providerData[prov]?.query
                                                                        ) : (
                                                                            "-"
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td
                                                                        style={{
                                                                            fontWeight: 800,
                                                                            verticalAlign: "middle",
                                                                            padding: "10px 8px"
                                                                        }}
                                                                    >
                                                                        Cited:
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            verticalAlign: "middle",
                                                                            padding: "10px 8px"
                                                                        }}
                                                                    >
                                                                        {providerData[prov]?.cited == null ? (
                                                                            "-"
                                                                        ) : providerData[prov].cited ? (
                                                                            <CheckCircleIcon style={{ color: "green" }} />
                                                                        ) : (
                                                                            <CancelIcon style={{ color: "red" }} />
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td
                                                                        style={{
                                                                            fontWeight: 800,
                                                                            verticalAlign: "middle",
                                                                            padding: "10px 8px"
                                                                        }}
                                                                    >
                                                                        Cited URLs:
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            verticalAlign: "middle",
                                                                            padding: "10px 8px"
                                                                        }}
                                                                    >
                                                                        {providerData[prov]?.cited_url?.length ? (
                                                                            providerData[prov].cited_url.map((url, index) => (
                                                                                <div key={index}>
                                                                                    <a
                                                                                        href={url}
                                                                                        target="_blank"
                                                                                        rel="noopener noreferrer"
                                                                                    >
                                                                                        {url}
                                                                                    </a>
                                                                                </div>
                                                                            ))
                                                                        ) : (
                                                                            "-"
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    )}
                                                </div>
                                            )
                                        ))}
                                        <div style={{ marginTop: "24px" }}>
                                            <DatagridComp
                                                columns={tableColumns}
                                                rows={tableRows}
                                                autoheightval={false}
                                                datagridval={2}
                                                columnFreezeWidth={[]}
                                                tableLoading={tableLoading}
                                                handleDownlodingCSV={csvdown}
                                                handleDownlodingPDF={pdfdown}
                                                DownloadShowFile={true}
                                                DownloadShowPDF={1}
                                                DownloadShowCSV={2}
                                                getRowId={(row) => row.id}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Box>
                </Container>
                ) : (
                  <Freeaudit planStatus={performancePlan} />
                )}

                <Container maxWidth={false} className="footer-container">
                    <Box className="footer-box">
                        <Grid container className="footer-grid">
                            <Grid item xs={12} md={6}>
                                <div className="footer-left">
                                    <p className="footer-text">
                                        All Rights Reserved Copyright © 2026 |
                                        <a href="https://www.egrovesys.com/" target="blank">
                                            <span className="footer-brand"> Elite site Optimizer</span>
                                        </a>
                                    </p>
                                </div>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <div className="footer-right">
                                    <p>{/* Add content if needed */}</p>
                                </div>
                            </Grid>
                        </Grid>
                    </Box>
                </Container>

                <div className="cnt_audit_outer_wrap">
                    <div >
                        {toggle && <Rightsidebar close={() => setToggle(false)} setToggle={setToggle} initialfaqDateval={initialfaqDateval} />}
                    </div>
                </div>
                <CommonErrorAlert
                    data={{
                        apiopen: successApiopen,
                        apiErrorMsg: successApierrorMsg,
                        isIconStyled: false
                    }}
                    closeAlert={successApiClose} />

                <CommonErrorAlert
                    data={{
                        apiopen: apiopen,
                        apiErrorMsg: apierrorMsg,
                        isIconStyled: true
                    }}
                    closeAlert={apihandleClose}
                />
               
        <Dialog
          open={citedUrlModalOpen}
          onClose={() => setCitedUrlModalOpen(false)}
          aria-labelledby="cited-url-dialog-title"
          aria-describedby="cited-url-dialog-description"
          className="cited-url-modal"
        >
          <DialogTitle id="cited-url-dialog-title">Cited URLs</DialogTitle>
          <DialogContent>
            <DialogContentText id="cited-url-dialog-description">
              {selectedCitedUrls.length > 0 ? (
                <ul>
                  {selectedCitedUrls.map((url, index) => (
                    <li key={index}>
                      <a href={url} target="_blank" rel="noopener noreferrer">
                        {url}
                      </a>
                    </li>
                  ))}
                </ul>
              ) : (
                <p>No cited URLs available.</p>
              )}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <button onClick={() => setCitedUrlModalOpen(false)}>Close</button>
          </DialogActions>
        </Dialog>
            </div>
        </>
    );
}